import { Navigate, useLocation } from "react-router-dom";
import { ReactNode } from "react";
import { TOKEN } from "../Login/Login";
// TODO: Update the import path if necessary
// If the file does not exist, create it at src/utils/constants.ts with the following content:
// export const TOKEN = "your_token_key";
interface PrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const location = useLocation();
  const token = localStorage.getItem(TOKEN);
  const isAuthenticated = Boolean(token);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export default PrivateRoute;
